import TemplateView from '../../../../../../TemplateView'
import {connect} from '../../../../../../redux/utils'
import Button from '../../../../../../components/Button'
import messageResource from '../../../../../../messageResource'
import {getCountry, getFileName, getHolidays, getYear, hasHolidaysInPast, hasHolidaysOnLeaveBlackoutDays, isImportHolidaysInProcess} from '../selectors'
import ImportHolidaysList from './ImportHolidaysList'
import {closePanel, importHolidays} from '../actions'
import {bindActionCreators} from 'redux'
import ScrollableContainer from '../../../../../../util/ScrollableContainer'
import EmptyList from '../../components/EmptyList'

class ImportHolidaysPanelContent extends TemplateView {
    constructor({
        onCancelClick,
        onImportButtonClick = () => {},
    }) {
        super()

        this.actions = {
            onCancelClick,
            onImportButtonClick,
        }

        this.state = {
            year: '',
            country: null,
            fileName: null,
            holidays: [],
            hasHolidaysInPast: false,
            hasHolidaysOnLeaveBlackoutDays: false,
            importProcess: false,
        }

        this.onAnyStatePropertyChanged(['country', 'fileName', 'year'], () => {
            const title = this.state.country !== null
                          ? messageResource.getMessage('work_schedule.import_panel.title_country', [this.state.country, this.state.year])
                          : messageResource.getMessage('work_schedule.import_panel.title_file', [this.state.fileName, this.state.year])
            this.$panelTitle.text(title)
        })

        this.onStatePropertyChanged('holidays', (holidays) => {
            this.holidayList.setState({holidays})
            const hasHolidays = Object.keys(holidays).length > 0
            this.$emptyListPlaceholder.toggle(!hasHolidays)
            this.$holidayListPlaceholder.toggle(hasHolidays)
            this.importButton.setState({disabled: !hasHolidays})
            this.holidayList.forceUpdate()
        })

        this.onAnyStatePropertyChanged(['hasHolidaysInPast', 'hasHolidaysOnLeaveBlackoutDays'], ({hasHolidaysInPast, hasHolidaysOnLeaveBlackoutDays}) => {
            const textKey = hasHolidaysOnLeaveBlackoutDays
                ? hasHolidaysInPast ? 'work_schedule.import_panel.past_and_blackout_holiday_note' : 'work_schedule.import_panel.blackout_holiday_note'
                : hasHolidaysInPast ? 'work_schedule.import_panel.past_holiday_note' : ''

            this.$hasFilteredNote
                .toggle(textKey !== '')
                .find('.text').text(messageResource.getMessage(textKey))
        })

        this.onStatePropertyChanged('importProcess', (importProcess) => {
            this.$importButton.toggleClass('loading', importProcess)
            this.importButton.setState({
                label: importProcess ? '' : messageResource.getMessage('common.import')
            })
        })
    }

    templateHtml() {
        return '<div class="importHolidaysPanelContent">' +
               '    <div class="panelTitle"/>' +
               '    <div class="holidayListContainer">' +
               '        <div class="listHeader">' +
               '            <div class="title"><%=listTitle%></div>' +
               '            <div class="note">' +
               '                <div class="icon"/>' +
               '                <div class="text"/>' +
               '            </div>' +
               '        </div>' +
               '        <div class="holidayListPlaceholder"></div>' +
               '        <div class="emptyListPlaceholder"></div>' +
               '    </div>' +
               '    <div class="footer">' +
               '        <div class="importButton"/>' +
               '        <div class="cancelButton"/>' +
               '    </div>' +
               '</div>'
    }

    messageKeys() {
        return {
            listTitle: 'work_schedule.import_panel.list_title',
        }
    }

    afterRender() {
        this.$panelTitle = this.find('.panelTitle')
        this.$hasFilteredNote = this.find('.listHeader .note')
        this.$importButton = this.find('.importButton')
        this.$emptyListPlaceholder = this.find('.emptyListPlaceholder')
        this.$holidayListPlaceholder = this.find('.holidayListPlaceholder')

        this.emptyList = new ScrollableContainer(
            null,
            new EmptyList()
        ).init((this.$emptyListPlaceholder))
        this.emptyList.setState({title: messageResource.getMessage('work_schedule.import.empty_list_title')})

        this.holidayList = new ScrollableContainer(
            null,
            new ImportHolidaysList(),
        ).init(this.$holidayListPlaceholder)

        this.importButton = new Button({
            additionalClass: 'import',
            label: messageResource.getMessage('common.import'),
            onClickCb: () => this.actions.onImportButtonClick()
        }).init(this.$importButton)

        new Button({
            additionalClass: 'cancel',
            label: messageResource.getMessage('common.cancel'),
            onClickCb: () => this.actions.onCancelClick()
        }).init(this.find('.cancelButton'))
    }
}

export default connect(
    state => ({
        year: getYear(state),
        country: getCountry(state),
        fileName: getFileName(state),
        holidays: getHolidays(state),
        hasHolidaysInPast: hasHolidaysInPast(state),
        hasHolidaysOnLeaveBlackoutDays: hasHolidaysOnLeaveBlackoutDays(state),
        importProcess: isImportHolidaysInProcess(state),
    }),
    dispatch => ({
        onImportButtonClick: bindActionCreators(importHolidays, dispatch),
        onCancelClick: bindActionCreators(closePanel, dispatch),
    }),
)(ImportHolidaysPanelContent)



// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/components/panels/importHolidays/components/ImportHolidaysPanelContent.js